import apiRequest from '@/utils/apiRequest';

export interface BgPublicConfig {
  enabled: boolean;
  showLobbyLink: boolean;
  showBetHistoryLink: boolean;
}

export async function getBgConfig(): Promise<BgPublicConfig> {
  return apiRequest<BgPublicConfig>('/public/bg/config', {
    method: 'GET',
  });
}

export async function getBgVideoGameUrl(params: {
  mobile?: boolean;
  gameType?: number;
  clientOrigin: string;
}): Promise<string> {
  const query = new URLSearchParams();
  query.set('mobile', String(params.mobile ?? true));
  query.set('clientOrigin', params.clientOrigin);
  if (params.gameType != null) {
    query.set('gameType', String(params.gameType));
  }
  return apiRequest<string>(`/bg/video/url?${query.toString()}`, {
    method: 'POST',
  });
}

interface PageResult<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface BgTransactionRecord {
  id: string;
  txKey: string;
  tranId?: string;
  orderId?: number;
  userId?: number;
  loginId?: string;
  txType: string;
  moduleId?: number;
  gameId?: number;
  orderStatus?: number;
  amount?: number;
  orderAmount?: number;
  validAmount?: number;
  balanceBefore?: number;
  balanceAfter?: number;
  createDate: string;
}

export interface BgBetSummaryRecord {
  id: string;
  orderId: number;
  tranId?: string;
  moduleId?: number;
  gameId?: number;
  gameName?: string;
  iconUrl?: string;
  betAmount: number;
  winAmount: number;
  transferAmount: number;
  settled: boolean;
  transactionCount: number;
  createDate: string;
}

export async function getBgBetSummaries(params?: {
  page?: number;
  pageSize?: number;
}): Promise<PageResult<BgBetSummaryRecord>> {
  return apiRequest<PageResult<BgBetSummaryRecord>>('/bg/betSummaries', {
    method: 'POST',
    data: {
      page: params?.page ?? 0,
      pageSize: params?.pageSize ?? 20,
    },
  });
}

export async function getBgBetSummaryTransactions(orderId: number): Promise<BgTransactionRecord[]> {
  return apiRequest<BgTransactionRecord[]>(`/bg/betSummary/transactions?orderId=${encodeURIComponent(String(orderId))}`, {
    method: 'POST',
  });
}
